import React from 'react';
import PropTypes from 'prop-types';
import AlertModal from 'components/modals/types/AlertModal';
import ConfirmModal from 'components/modals/types/ConfirmModal';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { closeModal } from 'store/actions/modalActions';
import { connect } from 'react-redux';

class Modal extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        if (utils.diffObjects(this.props, nextProps) ||
            utils.diffObjects(this.state, nextState)) {
            return true;
        }

        return false;
    }

    components = {
        alert: AlertModal,
        confirm: ConfirmModal,
    };

    handleDialogCancel = () => {
        const { actions, closeModal } = this.props;

        if (typeof actions.cancel === 'function') {
            return actions.cancel();
        }

        closeModal();
    }

    handleDialogSubmit = () => {
        const { actions, closeModal } = this.props;

        if (typeof actions.submit === 'function') {
            return actions.submit();
        }

        closeModal();
    }

    generateActions = (category) => {
        const { translate } = this.props;
        let result = [];

        const CancelButton = <RaisedButton
            key='cancel'
            label={ translate('actions.cancel') }
            onTouchTap={ this.handleDialogCancel }
            style={ { marginRight: '20px' } }
        />;

        const SubmitButton = <RaisedButton
            key='submit'
            keyboardFocused={ true }
            label={ translate('actions.ok') }
            onTouchTap={ this.handleDialogSubmit }
            primary
        />;

        switch (category) {
            case 'alert':
                result = [
                    SubmitButton,
                ];
                break;
            case 'confirm':
                result = [
                    CancelButton,
                    SubmitButton,
                ];
                break;
            default:
                result = [
                    CancelButton,
                    SubmitButton,
                ];
                break;
        }

        return result;
    }

    render() {
        const {
            category,
            content,
            isLoading,
            modal,
            open,
            title,
        } = this.props;

        if (!category) {
            return null;
        }

        const ModalComponent = this.components[this.props.category];

        return (
            <Dialog
                actions={ this.generateActions(category) }
                actionsContainerStyle={ {
                    padding: '20px 20px 20px 0',
                } }
                bodyStyle={ {
                    padding: '0 20px',
                } }
                modal={ modal }
                onRequestClose={ this.handleDialogClose }
                open={ open }
                overlayStyle={ {
                    backgroundColor: 'rgba(237, 236, 236, 0.6)',
                } }
                title={ title ? title : null }
                titleStyle={ {
                    padding: '30px 20px 10px',
                    margin: '0',
                } }
            >
                <ModalComponent
                    isLoading={ isLoading }
                    { ...content }
                />
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.modal,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        closeModal: (() => {
            dispatch(closeModal());
        }),
    };
};

Modal.propTypes = {
    actions: PropTypes.object,
    category: PropTypes.string,
    closeModal: PropTypes.func.isRequired,
    content: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    modal: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(Modal);



// WEBPACK FOOTER //
// ./src/components/modals/Modal.js